import React, {createContext} from 'react';

let defaultContext = {}
const AppContext = createContext(null);
export default AppContext;